export default [
  {
    path: '/uuidUpgrade',
    component: () => import('@/views/ota/uuidUpgrade.vue'),
    name: 'upgrade',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/uuidUpgrade2',
    component: () => import('@/views/ota/uuidUpgrade2.vue'),
    name: 'upgrade2',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
    redirect: (to) => {
      const vinNo = to.query.id || to.query.vinNo;
      return { name: 'ota-instrument-upgrade', params: { vinNo } };
    },
  },
  {
    path: '/uuidInstru',
    component: () => import('@/views/ota/uuidInstru.vue'),
    name: 'uuidInstru',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/zeeho2Upgrade',
    component: () => import('@/views/ota/zeeho2Upgrade.vue'),
    name: 'zeeho2Upgrade',
    meta: {
      title: '固件升级',
      backgroundClass: 'bg-gradientBlue',
      keepAlive: true,
    },
  },
  {
    path: '/zeeho2UpgradeV2',
    component: () => import('@/views/ota/zeeho2UpgradeV2.vue'),
    name: 'zeeho2UpgradeV2',
    meta: {
      title: '固件升级',
      backgroundClass: 'bg-gradientBlue',
      keepAlive: true,
    },
  },
  {
    path: '/ota/instrument/upgrade/:vinNo',
    component: () => import('@/views/ota/instrument/Upgrade.vue'),
    name: 'ota-instrument-upgrade',
    meta: {
      title: 'OTA',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/uuidInstruZeeho2',
    component: () => import('@/views/ota/uuidInstruZeeho2.vue'),
    name: 'uuidInstruZeeho2',
    meta: {
      title: '升级助手',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/guideZeeho2',
    component: () => import('@/views/ota/guideZeeho2.vue'),
    name: 'guideZeeho2',
    meta: {
      title: '',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/question/:vinNo',
    component: () => import('@/views/ota/instrument/Question.vue'),
    name: 'ota-instrument-question',
    meta: {
      title: '升级问题',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/question2/:vinNo',
    component: () => import('@/views/ota/instrument/Question2.vue'),
    name: 'ota-instrument-question2',
    meta: {
      title: '升级问题',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/connect/:vinNo',
    component: () => import('@/views/ota/instrument/Connect.vue'),
    name: 'ota-instrument-connect',
    meta: {
      title: '连接热点',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/assistant/:vinNo',
    component: () => import('@/views/ota/instrument/Assistant.vue'),
    name: 'ota-instrument-assistant',
    meta: {
      title: '升级助手',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/accCruiseInstruction',
    component: () => import('@/views/ota/instrument/AccCruiseInstruction.vue'),
    name: 'ota-instrument-AccCruiseInstruction',
    meta: {
      title: 'ACC自适应巡航功能说明',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/eventSearch',
    component: () => import('@/views/ota/EventSearch.vue'),
    name: 'ota-eventSearch',
    meta: {
      title: '升级状态查询',
      backgroundClass: 'bg-dark',
    },
  },
];
